var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.644
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4A4A4A",
    fillRule: "nonzero",
    stroke: "#4A4A4A",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5.765c3.174 0 5.735 2.561 5.735 5.735 0 3.174-2.561 5.735-5.735 5.735C3.326 12.235.765 9.674.765 6.5.765 3.326 3.326.765 6.5.765zM6.5 0C2.925 0 0 2.925 0 6.5S2.925 13 6.5 13 13 10.075 13 6.5 10.075 0 6.5 0zm.401 3.747c.115-.115.173-.248.173-.401 0-.153-.058-.306-.173-.402-.21-.21-.592-.21-.802 0-.115.115-.173.249-.173.402 0 .153.058.305.173.401.114.115.248.172.401.172.153 0 .306-.057.401-.172zm-.019 5.907V4.875c0-.21-.172-.382-.382-.382-.21 0-.382.172-.382.382v4.78c0 .21.172.382.382.382.21 0 .382-.172.382-.383z",
    transform: "translate(-333 -229) translate(334 230)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.4a0ad95f.svg";
export { ForwardRef as ReactComponent };